import { render } from "./LeaveWorkflowHistoryModal.vue?vue&type=template&id=da221100&scoped=true"
import script from "./LeaveWorkflowHistoryModal.vue?vue&type=script&lang=js"
export * from "./LeaveWorkflowHistoryModal.vue?vue&type=script&lang=js"

import "./LeaveWorkflowHistoryModal.vue?vue&type=style&index=0&id=da221100&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da221100"]])

export default __exports__